var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F22C56C2-D286-45FA-96B0-41D76A230821") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-order",
    transform: "translate(-704, -18)",
    fill: "#CEFAB7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-app-menu",
    transform: "translate(447, 18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "order-icon",
    transform: "translate(257, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,3 C8.82029825,3 3,8.82029825 3,16 C3,23.1797017 8.82029825,29 16,29 C23.1797017,29 29,23.1797017 29,16 C29,8.82029825 23.1797017,3 16,3 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,25.3333333 C15.6222667,25.3333333 15.3056,25.2056 15.05,24.95 C14.7944,24.6944 14.6666667,24.3777333 14.6666667,24 L14.6666667,17.3333333 L8,17.3333333 C7.62222667,17.3333333 7.30556,17.2056 7.05,16.95 C6.79444,16.6944 6.66666667,16.3777333 6.66666667,16 C6.66666667,15.6222667 6.79444,15.3056 7.05,15.05 C7.30556,14.7944 7.62222667,14.6666667 8,14.6666667 L14.6666667,14.6666667 L14.6666667,8 C14.6666667,7.62222667 14.7944,7.30556 15.05,7.05 C15.3056,6.79444 15.6222667,6.66666667 16,6.66666667 C16.3777333,6.66666667 16.6944,6.79444 16.95,7.05 C17.2056,7.30556 17.3333333,7.62222667 17.3333333,8 L17.3333333,14.6666667 L24,14.6666667 C24.3777333,14.6666667 24.6944,14.7944 24.95,15.05 C25.2056,15.3056 25.3333333,15.6222667 25.3333333,16 C25.3333333,16.3777333 25.2056,16.6944 24.95,16.95 C24.6944,17.2056 24.3777333,17.3333333 24,17.3333333 L17.3333333,17.3333333 L17.3333333,24 C17.3333333,24.3777333 17.2056,24.6944 16.95,24.95 C16.6944,25.2056 16.3777333,25.3333333 16,25.3333333 Z",
    id: "Path",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIconActive);
export default __webpack_public_path__ + "static/media/order-icon-active.c826b1320005543db0202d83a2b1f1a6.svg";
export { ForwardRef as ReactComponent };